import {json} from '../../../core/data-source/json.mapper';

export class ReportedLoadingOrderRecord {
    @json()
    sequenceNumber: number;

    @json()
    id: number;

    @json()
    reference: string;

    @json()
    plannedItems: number;

    @json()
    loadedItems: number;

    @json()
    deliveredItems: number;

    @json()
    status: string;
}
